<template>
  <div id="article-ranking">
    <div class="flex mar-b-20 article-ranking-title"
         style="align-items: center;
    justify-content: space-between;">
      <div class="ipub-h1 flex-center">
        Article Ranking
        <div class="ipubw-p1 mar-l-20">
          <ipub-select v-model="titleStatu"
                       style="width:150px"
                       @change="changeArticalTime">
            <ipub-select-option :value="item.statu"
                                v-for="item in titleTab"
                                :key="item.title">
              {{item.title}}
            </ipub-select-option>
          </ipub-select>
        </div>
      </div>
      <div class="flex article-ranking-title-more"
           style="align-items:center">
        <ipub-button type="primary"
                     size="small"
                     style="width:80px"
                     @click="exportArtical">
          Export
        </ipub-button>
      </div>
    </div>
    <div class="artical-ranking-table">
      <ipub-table :columns="columns"
                  :pagination="false"
                  @order="onOrderChanage"
                  :dataSource="dataSource">

        <template v-slot:index="{index}">
          {{index+1}}
        </template>
        <template v-slot:country="{text}">
          <div class="omis"> {{country[text]}}</div>
        </template>
        <template v-slot:title="{text}">
          <ipub-tooltip>
            <div slot="title">
              <div v-html="text"></div>
            </div>
            <div class="omission-2">
              <div v-html="text"></div>
            </div>
          </ipub-tooltip>
        </template>
      </ipub-table>
    </div>
  </div>
</template>

<script>
import { statisticArticle } from '@/api/statistic'
import help from '@/utils/help'
import { mapGetters } from 'vuex'

const columns = [
  {
    title: '',
    enTitle: 'Rank',
    width: 60,
    dataIndex: '',
    slot: 'index'
  },
  {
    title: '',
    enTitle: 'Article Title',
    width: 200,
    dataIndex: 'title',
    slot: 'title'
  },
  {
    title: '',
    enTitle: 'Abstract',
    width: 100,
    dataIndex: 'summaryNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'PDF',
    width: 70,
    dataIndex: 'pdfDownloadNum',
    // slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Cited',
    width: 70,
    dataIndex: 'citeNum',
    // slot: 'omis'
  },
  {
    title: '',
    enTitle: 'Country',
    width: 100,
    dataIndex: 'countryName',
    slot: 'omis'
  }
]
export default {
  props: {
    journalId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      titleTab: [
        { title: 'Yesterday', statu: 1 },
        { title: 'Latest 7 days', statu: 2 },
        { title: 'Latest 30 days', statu: 3 },
        { title: 'This year', statu: 4 }
      ],
      titleStatu: 1,
      columns: columns,
      dataSource: [],
      params: {
        accessDateStart: this.$moment().subtract(1, 'days'),
        accessDateEnd: this.$moment(),
        sorted: '-summaryNum',
        limit: 14
      }
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
    })
  },
  watch: {
    journalId: {
      handler (newV) {
        // console.log(newV, 'x新增')
        if (newV) {
          this.getStatisticArticle()
        }
      },
      immediate: true
    }
  },
  mounted () {
    // this.getStatisticArticle()
  },
  methods: {
    changeArticalTime (val) {
      this.titleStatu = val
      switch (val) {
        case 1:
          this.params.accessDateStart = this.$moment().subtract(1, 'days')
          break;
        case 2:
          this.params.accessDateStart = this.$moment().subtract(1, 'weeks')
          break;
        case 3:
          this.params.accessDateStart = this.$moment().subtract(1, 'months')
          break;
        case 4:
          this.params.accessDateStart = this.$moment().subtract(1, 'years')
          break;
      }
      this.params.accessDateEnd = this.$moment()
      this.getStatisticArticle()
      // console.log(this.params.accessDateStart, '开始时间')
      // console.log(this.params.accessDateEnd, '结束时间')

    },
    async getStatisticArticle () {
      let journalId = this.journalId
      let data = Object.assign(this.params, {
        journalId
      })
      let res = await statisticArticle.get(data)
      this.dataSource = res.length > 14 ? res.slice(0, 14) : res
    },
    async exportArtical () {
      let journalId = this.journalId
      let data = Object.assign(this.params, {
        journalId
      })
      // console.log(data, '参数')
      const res = await statisticArticle.export(data)
      help.download(res.url, res.fileName)
    },
    onOrderChanage (val) {
      this.params.sorted = val
      this.getStatisticArticle()
    }
  }
}

</script>
<style lang="scss" scoped>
#article-ranking {
  margin-right: 20px;
  &-title {
    justify-content: space-between;
    align-items: center;

    &-more {
      justify-content: space-between;
      align-items: center;
    }
  }
}
.title-tab {
  &-title {
    position: relative;
    transition: 0.3s all;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -5px;
      height: 2px;
      background: $link_color;
      width: 0;
      transition: 0.3s all;
    }
    &-active,
    &:hover {
      color: $link_color;
      &::after {
        width: 36px;
      }
    }
  }
}
</style>
